import { Icons } from '@lemon/assets';
import { useEffect, useState } from 'react';

export const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < 10) {
                // 최상단에서는 항상 표시
                setIsVisible(true);
            } else if (currentScrollY > lastScrollY) {
                // 스크롤 내림 - 헤더 숨김
                setIsVisible(false);
                setIsMenuOpen(false); // 메뉴도 닫기
            } else {
                // 스크롤 올림 - 헤더 표시
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    const handleItemClick = (id: string) => {
        const el = document.getElementById(id);

        if (el) {
            const headerOffset = 100; // 헤더 높이
            const elementPosition = el.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
        setIsMenuOpen(false);
    };

    return (
        <div
            className={`fixed top-0 left-0  w-full flex justify-between items-center h-[100px] bg-gray-950 backdrop-blur-xl z-[100] transition-transform duration-300 ${
                isVisible ? 'translate-y-0' : '-translate-y-full'
            }`}
        >
            <div className="flex items-center w-full text-white h-full max-w-[1200px] mx-auto justify-between px-4 md:px-8">
                <div className="flex items-center">
                    <img src={Icons.logo} className="h-6 brightness-0 invert" alt="epyt logo" />
                </div>

                {/* Desktop Menu */}
                <div className="hidden md:flex items-center gap-8 lg:gap-10">
                    {headers.map(item => (
                        <div
                            key={item.id}
                            className="whitespace-nowrap cursor-pointer py-2 px-3 -mx-3 rounded-lg hover:bg-white/10 hover:scale-105 transition-all duration-200"
                            onClick={() => handleItemClick(item.id)}
                        >
                            {item.title}
                        </div>
                    ))}
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden flex flex-col gap-1.5 w-7 h-7 justify-center items-center"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="메뉴"
                >
                    <span
                        className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                            isMenuOpen ? 'rotate-45 translate-y-2' : ''
                        }`}
                    />
                    <span
                        className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}
                    />
                    <span
                        className={`w-6 h-0.5 bg-white transition-all duration-300 ${
                            isMenuOpen ? '-rotate-45 -translate-y-2' : ''
                        }`}
                    />
                </button>

                {/* <div className="whitespace-nowrap" onClick={handleEngClick}>
                    ENG
                </div> */}
            </div>

            {/* Mobile Menu Dropdown */}
            {isMenuOpen && (
                <div className="md:hidden absolute top-[100px] left-0 w-full bg-[#000000] z-[100]">
                    <div className="flex flex-col max-w-[1200px] mx-auto px-4 py-6 gap-2">
                        {headers.map(item => (
                            <div
                                key={item.id}
                                className="text-white py-4 px-5 cursor-pointer hover:bg-white/10 hover:scale-[1.02] active:scale-95 rounded-lg transition-all duration-200"
                                onClick={() => handleItemClick(item.id)}
                            >
                                {item.title}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export const headers = [
    {
        id: 'brand',
        title: '브랜드 소개',
    },
    {
        id: 'philosophy',
        title: '생각하는 가치',
    },
    {
        id: 'problem',
        title: '해결하고자 하는 문제',
    },
    {
        id: 'function',
        title: '기능',
    },
    {
        id: 'creator',
        title: '크리에이터 모집',
    },
    {
        id: 'download',
        title: '앱 다운로드',
    },
];
